// hooks/usePhoneNumber.js
import { useLocation } from "react-router-dom";
import { useMemo } from "react";

export const usePhoneNumber = () => {
  const location = useLocation();

  // Define your phone numbers for calling (display wale)
  const defaultPhone = "+971 45 401 303";
  const categoryPhone = "+971 45 401 303";

  // Define your WhatsApp numbers (without + or spaces for WhatsApp URL)
  const defaultWhatsApp = "971544252878";
  const categoryWhatsApp = "971544252878";

  // Keywords for special categories
  const categoryKeywords = [
    "telehandler",
    "telehandlers",
    "skid-steer",
    "mini-excavator",
    "mini-excavators"
  ];

  // Detect if current route belongs to special categories
  const isSpecialCategory = useMemo(() => {
    const path = location.pathname.toLowerCase();
    return categoryKeywords.some(keyword => path.includes(keyword));
  }, [location.pathname]);

  // Handle query params for product attribute pages
  const searchParams = new URLSearchParams(location.search);
  const paCategory = searchParams.get("pa_categories");
  const matchesQuery = categoryKeywords.some(keyword => 
    paCategory?.toLowerCase().includes(keyword)
  );

  const isCategory = isSpecialCategory || matchesQuery;

  // Return both phone and WhatsApp numbers
  return {
    phone: isCategory ? categoryPhone : defaultPhone,
    whatsapp: isCategory ? categoryWhatsApp : defaultWhatsApp
  };
};